// 已废弃 - 项目路由现在直接在 router.js 中定义
// 保留此文件仅为兼容性

export default []
